module.exports = __webpack_public_path__ + "img/_Middle-Vertical-Rectangular-Attachment.e4e018cd.jpg";